<template>
  <BaseLink v-bind="$attrs">
    <BaseFigure :caption="caption">
      <slot />
    </BaseFigure>
  </BaseLink>
</template>

<script>
// import TypolinkMixin from '@/js/mixins/typolink-mixin.js'

export default {
  name: 'BaseLinkedFigure',
  // mixins: [TypolinkMixin],
  props: {
    caption: {
      type: String,
      default: '',
    },
  },
}
</script>

<style></style>
